import {
    type FC
} from "react";
import type IDropdownMenuEmptyProps from "./type";
import {
    useDropdownMenuContext
} from "../../context";
import PopoverSurface from "../../../popoverSurface";

const DropdownMenuEmpty: FC<IDropdownMenuEmptyProps> = ({
    customLocalize: customLocalizeProp,
    customTheme: customThemeProp,
    ...props
}) => {
    const context = useDropdownMenuContext({
        part: "Empty"
    });

    return <PopoverSurface.Empty
        {...props}
        customLocalize={customLocalizeProp ?? context?.customLocalize}
        customTheme={customThemeProp ?? context?.customTheme}
    />;
};
export default DropdownMenuEmpty;
